module.exports = __webpack_public_path__ + "03_long_black.f51f6157.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_long_black.png
// module id = RXfY
// module chunks = 0